import { useOrderContext } from "app/providers/OrderProvider";
import StatusGif from "entities/status-gif";
import CustomLink from "shared/ui/typography/CustomLink";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";
import { isTestEnvironment } from "shared/utils/checkEnvironment";
import { twMerge } from "tailwind-merge";
import StatusSupport from "widgets/status-support";

const AppointmentLater = () => {
  const { order } = useOrderContext();

  return (
    <>
      {order && (
        <div
          className={twMerge(
            isTestEnvironment() ? "gg-mx-auto" : "",
            "gg-max-w-3xl",
          )}
        >
          <div className="gg-mb-14">
            <StatusGif
              src={`https://media1.giphy.com/media/XEzlPjgj6eCu3AZPhu/giphy.gif`}
              alt="Een GewoonGers Gif. Inmeter zwaait vanuit de auto."
            />

            <Heading
              headingLevel="h1"
              className="gg-mb-3 md:gg-mb-5 md:gg-text-6xl"
            >
              Plan je inmeet - afspraak later
            </Heading>

            <Text className="gg-mb-3 gg-text-xl md:gg-mb-5 md:gg-text-2xl">
              Hallo {order?.shippingAddress.firstName}{" "}
              {order?.shippingAddress.lastName},
            </Text>

            <Text className="gg-mb-3 gg-text-lg">
              Je hebt ervoor gekozen je inmeetdatum later te plannen. Je krijgt
              een bevestiging per e-mail met daarin toegang tot onze online
              agenda. Zo kun je op ieder gewenst moment zelf een gratis
              inmeetafspraak plannen.{" "}
            </Text>

            {order !== undefined && order.shippingAddress !== undefined && (
              <Text className="gg-mb-3 gg-text-lg">
                Laat je ons weten wanneer we welkom zijn op{" "}
                <span className="gg-font-bold">
                  {order.shippingAddress.street}{" "}
                  {order.shippingAddress.houseNumber},{" "}
                  {order.shippingAddress.zip} in {order.shippingAddress.city}
                </span>
                ?
              </Text>
            )}

            <Text className="gg-mb-3 gg-text-lg">
              Na deze afspraak hebben wij inzichtelijk wat je wensen zijn en kun
              jij besluiten of je over wilt gaan tot bestelling.{" "}
            </Text>

            <Text className="gg-text-lg">
              Heb je vragen of opmerkingen? Neem dan gerust even contact met ons
              op en houd je bevestigingsnummer of postcode bij de hand. Contact
              ons via:{" "}
              <CustomLink
                to="mailto:info@gewoongers.nl"
                opacityTransition={false}
              >
                info@gewoongers.nl
              </CustomLink>{" "}
              of{" "}
              <CustomLink to="tel:010 3072889" opacityTransition={false}>
                010 3072889
              </CustomLink>
              .
            </Text>
          </div>

          <StatusSupport />
        </div>
      )}
    </>
  );
};
export default AppointmentLater;
